import { useQuery } from '@tanstack/react-query';
import { applicationService } from 'src/services/application';
import { useApplicationStore } from 'src/store/application';
import { InsurancePlan } from 'src/services/interfaces/insurance';

type AllowedPrice = InsurancePlan['prices'][0];

export const useAllowedPrices = (
  planId: number | undefined,
  coverage: number
) => {
  const currentApplicationId = useApplicationStore(
    (s) => s.currentApplicationId
  );

  const query = useQuery<AllowedPrice[]>({
    queryKey: ['allowedPrices', currentApplicationId, planId, coverage],
    queryFn: async () => {
      const data = await applicationService.getAllowedPrices(
        currentApplicationId!,
        planId!,
        coverage
      );
      return data as AllowedPrice[];
    },
    enabled: !!currentApplicationId && !!planId && coverage >= 1,
    staleTime: 5 * 60 * 1000,
  });

  return {
    allowedPrices: query.data ?? [],
    isLoading: query.isLoading,
    isFetched: query.isFetched,
  };
};
